import React from 'react';
import {
  Box,
} from '@mui/material';
import Close from '@mui/icons-material/Close';

const CloseButton: React.FC<{
  onClose: () => void,
}> = ({ onClose }) => (
  <Box
    onClick={onClose}
    display="flex"
    alignItems="center"
    justifyContent="center"
    zIndex={2}
    bgcolor="#F7F6FA"
    width="100%"
    height="100%"
    borderRadius="50%"
    p={0.5}
    sx={{
      cursor: 'pointer',
    }}
  >
    <Close
      sx={{
        width: '100%',
        height: '100%',
      }}
    />
  </Box>
);

export default CloseButton;
